module.exports = __webpack_public_path__ + "img/d1b139a9acdc6a95ee03dae57c3a2b2f.svg";